function NewAdHocConditionDefinition()  {
    return {
        id: null,       
        answerOption: {},
		conditionOperator: 0,
		conditions: []		
      }
}
export default NewAdHocConditionDefinition;